import { useEffect } from 'react'

let isInitialized = false

export const useTelegramInit = () => {
  useEffect(() => {
    if (!isInitialized) {
      const tg = window.Telegram.WebApp
      tg.ready()
      tg.expand()
      isInitialized = true
    }
  }, [])
}
